import * as React from 'react'

const UsersThreeIcon = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="21"
    fill="none"
    viewBox="0 0 28 21"
    ref={ref}
    {...props}
  >
    <path
      fill="#676879"
      d="M17.979 15.808a5.687 5.687 0 1 0-7.958 0 8.3 8.3 0 0 0-3.281 3.16 1.312 1.312 0 0 0 2.272 1.312 5.796 5.796 0 0 1 9.978 0 1.315 1.315 0 0 0 1.804.501 1.313 1.313 0 0 0 .468-1.813 8.3 8.3 0 0 0-3.283-3.16m-7.042-4.058a3.062 3.062 0 1 1 6.124 0 3.062 3.062 0 0 1-6.124 0m16.102 1.049a1.314 1.314 0 0 1-1.84-.261c-.91-1.213-2.17-2.143-3.207-2.367a1.312 1.312 0 0 1-.2-2.506 2.187 2.187 0 1 0-2.71-3.095 1.314 1.314 0 1 1-2.296-1.27A4.813 4.813 0 1 1 24.8 8.59 10.1 10.1 0 0 1 27.3 10.96a1.31 1.31 0 0 1-.262 1.838M6.008 10.174c-1.037.224-2.297 1.154-3.208 2.368A1.314 1.314 0 0 1 .7 10.962a10.1 10.1 0 0 1 2.5-2.373 4.812 4.812 0 1 1 8.014-5.288 1.311 1.311 0 0 1-1.512 1.922 1.31 1.31 0 0 1-.785-.653 2.188 2.188 0 1 0-2.71 3.095 1.313 1.313 0 0 1-.199 2.506z"
    ></path>
  </svg>
))

UsersThreeIcon.displayName = 'UsersThreeIcon'

export { UsersThreeIcon }
